import React, { memo, useMemo, useCallback } from "react";
import _, { isEqual } from 'lodash';
import { FormattedMessage, useIntl } from "react-intl";
import Pagination from '@material-ui/lab/Pagination';
import BallotOutlinedIcon from '@material-ui/icons/BallotOutlined';
// import memoizeOne from 'memoize-one';
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList as List, areEqual } from "react-window";
import ReactDataSheet from "../../react-datasheet/lib/index";
// import Cell from "./Cell";
import DataCell from "../../react-datasheet/lib/DataCell";
import '../../react-datasheet/lib/react-datasheet.css';
// import '../index.css';
import {
  colDragSource, colDropTarget,
  rowDragSource, rowDropTarget
} from './drag-drop.js'
import CommonHTML5Backend from "./CommonHTML5Backend";
import { Button, TextField, Checkbox, ClickAwayListener, Popper, Paper, Grow, InputAdornment, FormGroup, FormLabel, FormControlLabel, Switch } from '@material-ui/core';
import { props } from "ramda";
import PF from '../../_Services/publicFunction';
import useSound from 'use-sound';
import clickdown from '../sounds/clickdown.wav';
import clickup from '../sounds/clickdown.wav';

const Header = React.memo(colDropTarget(colDragSource((props) => {
  const { col, connectDragSource, connectDropTarget, isOver, onClick, dataKey, handleMouseMove, columns, columnIndex, FrozenColumn, enableCheck } = props
  const className = isOver ? 'drop-target shadow' : 'shadow'
  let accWidth = 0;
  // console.log(props);
  let styles = {};
  if (columnIndex + 1 <= FrozenColumn) {
    accWidth = columns.slice(0, columnIndex).reduce((a, b) => a + b.width, 0)
    styles = {
      left: enableCheck ? 85 + accWidth : 30 + accWidth,
      position: "sticky",
      zIndex: "100",
      // width:"500px",
      // background: "rgb(255,255,125)",
      border: "1px solid #a2a2a2",
    }
  }
  return connectDropTarget(
    connectDragSource(
      <th className={className} width={col.width} title={col.label || null} style={columnIndex + 1 <= FrozenColumn ? styles : null}>
        <span onMouseDown={onClick} className={"headerSpan"} >
          <FormattedMessage id={col.name} />
        </span>
        <span className="DragHandle DragHandleIcon" onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
          // console.log(e);
          handleMouseMove(e, dataKey)
        }}></span>
      </th>

    ))
})), isEqual);

const RenderHeader = React.memo((props) => {
  const { columns, FrozenColumn, onHeaderClick, onColumnDrop, handleMouseMove, enableCheck } = props;
  // console.log(props)
  return (
    columns.map((col, index) => (
      <Header FrozenColumn={FrozenColumn} onClick={() => onHeaderClick(index)} key={col.label} col={col} columnIndex={index} columns={columns}
        onColumnDrop={onColumnDrop} dataKey={index} handleMouseMove={handleMouseMove} className={"tableStickyHeaderCell"} enableCheck={enableCheck} />
    ))
  )
}, isEqual)
//const anchorRef = React.useRef(null);
const ButtonToggle = React.memo((props) => {
  const { OriginalColumns, setColumns, FrozenColumn, setFrozen, setOrderRows, OriginalRows } = props
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  // console.log(OriginalColumns)
  const handleSetColumnShow = (event) => {
    const { name, checked } = event.target;
    // console.log(name, checked)
    let colx = _.cloneDeep(OriginalColumns);
    colx[name].noshowTable = !checked
    setColumns(colx);

    let noshowTable = [];
    Object.values(colx).map(item => {
      if (item.noshowTable === true) {
        // console.log(item.name)
        noshowTable.push(item.name)
      }
    })
    let showColumns2 = _.omit(colx, noshowTable); //過濾不顯示的

    setOrderRows(prev => PF.dataSheetGridFormat(OriginalRows, Object.keys(showColumns2)))
  };
  //用於顯示開關
  let z = [];
  // console.log(props)
  Object.values(OriginalColumns).map(item => {
    if (item.noshowTableForever === true) {
      z.push(item.name)
    }
  })
  let z2 = _.omit(OriginalColumns, z); //過濾不顯示的
  return (
    <ClickAwayListener onClickAway={() => setOpen(false)} >
      <span>
        <Button size="small" ref={anchorRef} onClick={handleToggle}>
          <BallotOutlinedIcon style={{ float: "left" }} />
        </Button>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          //role={undefined}
          transition
          //disablePortal
          placement="top"
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
            >
              <Paper elevation={3} style={{ padding: "5px" }}>
                <FormGroup component="fieldset">
                  <FormLabel><FormattedMessage id={"app.ShowColumn"} /></FormLabel>
                  {Object.values(z2).map((item, index) => {
                    return (
                      <FormControlLabel
                        control={
                          <Switch
                            checked={!item.noshowTable}
                            color="primary"
                            onChange={handleSetColumnShow}
                            name={item.name}
                          />
                        }
                        label={<FormattedMessage id={item.name} />}
                        labelPlacement="start"
                        style={{ marginRight: 0 }}
                      />
                    )
                  })}
                  <FormLabel><FormattedMessage id={"app.FrozenColumn"} /></FormLabel>
                  <TextField type="number" name="frozen" value={FrozenColumn}
                    InputProps={{
                      startAdornment: <InputAdornment position="start"><FormattedMessage id={"app.ColumnCount"} /></InputAdornment>,
                    }}
                    onChange={e => setFrozen(e.target.value)}
                    inputProps={{ min: 0, step: 1, style: { textAlign: 'center' }, max: Object.keys(z2).length }} />
                </FormGroup>
              </Paper>
            </Grow>
          )}
        </Popper>
      </span>
    </ClickAwayListener>
  )
}, isEqual);


// const enableCheck = true;
class VirtualSheet extends ReactDataSheet {
  constructor(props) {
    super(props)
    this.handleCheckSelectionChanges = this.handleCheckSelectionChanges.bind(this);
    this.CheckSelectionAll = this.CheckSelectionAll.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.onHandleCopy = this.onHandleCopy.bind(this);
    // this.handleDoubleClick = this.props.handleDoubleClick.bind(this);
    this.thead = React.createRef();
  }
  handleMouseMove(event, dataKey) {
    const minWidth = 30;  //最小寬度
    let startPosition = event.pageX || 0;

    const { columns, setColumns, OriginalColumns } = this.props;
    //console.log(columns[dataKey].name);
    let colName = columns[dataKey].name;
    setColumns(prevState => ({
      ...prevState,
      [colName]: { ...prevState[colName], width: OriginalColumns[colName].width }
    }))
    // console.log(startPosition);
    // this.setState(prevState => {
    //   return {
    //     columns: prevState.columns.map((item, index) => {
    //       const newItem = _.cloneDeep(item);
    //       if (index === dataKey) {
    //         newItem.width = columns[dataKey].width;
    //       }
    //       return newItem;
    //     })
    //   };
    // });
    const handleMouseMoved = eventMoving => {
      // console.log(eventMoving,"MOVE")
      let diff = eventMoving.pageX - startPosition;
      //   console.log(diff);
      // if (OriginalColumns[colName].width + diff >= minWidth) {
      setColumns(prevState => ({
        ...prevState,
        [colName]: { ...prevState[colName], width: OriginalColumns[colName].width + diff >= minWidth ? OriginalColumns[colName].width + diff : minWidth }
      }))
      // this.setState(prevState => {
      //   return {
      //     columns: prevState.columns.map((item, index) => {
      //       //   console.log(item.width);
      //       const newItem = _.cloneDeep(item);
      //       if (index === dataKey) {
      //         newItem.width = columns[dataKey].width + diff;
      //       }
      //       return newItem
      //     })
      //   };
      // });
      // }
    }
    const handleMouseUp = eU => {
      // console.log(eU,"UP")
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('mousemove', handleMouseMoved);
    }
    window.addEventListener('mouseup', handleMouseUp);
    window.addEventListener('mousemove', handleMouseMoved);

  }
  CheckSelectionAll(e) {  //最上方的checkbox
    //const { checkSelections, grid } = this.state;
    const { data, rows, isMultipleCheckSelection, checkSelections, setCheckSelections } = this.props;
    if (!isMultipleCheckSelection) {
      //const numChecked = Object.values(checkSelections).length;
      const numChecked = checkSelections.size;
      if (numChecked > 0) {
        //setCheckSelections({});
        setCheckSelections(prev => {
          return new Map(prev.clear())
        });
      }
    } else {
      //const { checked } = e.target;
      const rowCount = data.length;
      const numChecked = new Map([...checkSelections].filter(([k, v]) => v === true)).size
      //console.log(numChecked);
      if (numChecked < rowCount) {
        // console.log("應該全選")
        // rows.map((item, key) => {
        //   setCheckSelections(prevState => ({
        //     ...prevState,
        //     [key]: true
        //   }))
        // })
        let y = Array.from(Array(rowCount).keys()).map(item => [item, true])
        setCheckSelections(prev => {
          return new Map(y)
        });
      } else if (numChecked === rowCount) {
        //setCheckSelections({})

        setCheckSelections(prev => {
          return new Map(prev.clear())
        });
      }
    }


  }
  handleCheckSelectionChanges(e, rowIndex) {
    // console.log(this.props)
    //const { checkSelections } = this.props;
    const { checkSelections, setCheckSelections, isMultipleCheckSelection } = this.props;
    // console.log(checkSelections,rowIndex);

    let chk = checkSelections.get(rowIndex) || false;
    //let result = e.target.checked;
    if (isMultipleCheckSelection === true) {  //多選

      // setCheckSelections(prevState => ({
      //   ...prevState,
      //   [rowIndex]: !chk
      // }))

      setCheckSelections(prev => new Map([...prev, [rowIndex, !chk]]))
    } else {

      // setCheckSelections(prevState => ({
      //   //...prevState,
      //   [rowIndex]: !chk
      // }))

      setCheckSelections(prev => {
        prev.clear();
        return new Map([...prev, [rowIndex, !chk]])
      });
    }
  }
  setRef = ref => {
    this.dgDom = ref;
  };
  // onSelect(selected) {
  //   this.setState({ selected });

  //   console.log(selected)
  // }
  // shouldComponentUpdate(nextProps, nextState) {
  //   // console.log(this.props.selected)
  //   // console.log(nextProps.selected)
  //   return nextProps.selected.start !== this.props.selected.start || nextProps.selected.end !== this.props.selected.end
  // }
  onHandleCopy = e => {
    // const intl = useIntl();

    e.preventDefault();
    const { selected, columns, data } = this.props
    const { start, end } = selected;

    let columnStart = start.j <= end.j ? start.j : end.j;
    let columnEnd = start.j <= end.j ? end.j : start.j;
    let rowStart = start.i <= end.i ? start.i : end.i;
    let rowEnd = start.i <= end.i ? end.i : start.i;

    let rowArr = [];

    for (let i = rowStart; i <= rowEnd; i++) {
      let colArr = [];

      for (let j = columnStart; j <= columnEnd; j++) {

        colArr.push(data[i][j].value)
      }
      rowArr.push(colArr.join('\t'));

    }
    let header = [];
    if (this.props.CopyWithHeader) { //是否複製有表頭
      header = columns.filter((obj, index) => columnStart <= index && index <= columnEnd)
        .map(obj => this.props.i18n ? this.props.i18n.messages[obj.name] : obj.name).join('\t');
    }

    let headRowArr = this.props.CopyWithHeader ? [header, ...rowArr] : rowArr;

    e.clipboardData.setData('text/plain', headRowArr.join('\n'));

  }
  // componentDidMount() {
  //   // console.log(`CowshedManagement componentDidMount`);
  //   // console.log(this.scrollItem);
  //   // this.scrollItem.addEventListener(‘scroll’, this.onListScroll);
  //   this.thead.addEventListener("scroll", console.log("X"));
  // }
  render() {
    const { data, OriginalRows, FrozenColumn, labelCount, setFrozen, OriginalColumns, setColumns, columns, pageCount, pageNo, listRef
      , checkSelections, onTotalClick, onHeaderClick, onColumnDrop, className, enableCheck, setOrderRows, defaultWidth
    } = this.props;
    const sheetwidth = columns.reduce((a, b) => a + b.width, 0)
    const numChecked = new Map([...checkSelections].filter(([k, v]) => v === true)).size
    //const numChecked = Object.values(checkSelections).reduce((a, b) => a + (b ? 1 : 0), 0);
    const rowCount = data.length;
    return (
      <div className={"table-responsive"} style={{ overflow: "hidden" }}>
        <table className={"data-grid"} style={{ width: defaultWidth }}>
          <thead
            // width={84+sheetwidth+18}
            className={'data-header'}
            ref={this.thead}
            //1em是scrollbarY寬度
            style={{
              overflow: 'hidden', display: 'flex'// , width: 'calc( 100% - 1em )' 
            }}
          // onScroll={console.log("sco")}
          >
            <tr
              style={{ display: 'flex' }}
              width={enableCheck ? 84 + sheetwidth - 16 : 30 + sheetwidth - 16}
            >
              <td
                className='topCornor'
                key='$$actionCell'
                width={30}
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  onTotalClick()
                }}
                onDoubleClick={e => { }}
              />
              {enableCheck === true ? (<td className='shadow' width={55} style={{ left: '30px', position: 'sticky', zIndex: 999 }}>
                <Checkbox
                  style={{ padding: 0, width: '100%', borderRadius: "0", color: "#3f51b5" }}
                  indeterminate={numChecked > 0 && numChecked < rowCount}
                  checked={numChecked === rowCount || false}
                  color={"primary"}
                  onChange={this.CheckSelectionAll}
                />
              </td>) : null}
              <RenderHeader FrozenColumn={FrozenColumn} className={"tableStickyHeaderCell"} columns={columns}
                handleMouseMove={this.handleMouseMove}
                onHeaderClick={onHeaderClick}
                onColumnDrop={onColumnDrop}
                enableCheck={enableCheck}
              />
            </tr>
          </thead>
          <div
            style={{ height: "550px", width: 'calc(100% + 1em)', display: 'flex', overflow: "auto" }}
            tabIndex="0"
            className="data-grid-container data-tbody" //除去黑框
            onKeyDown={this.handleKey.bind(this)}
            ref={this.setRef}
            onScroll={e => {
              // console.log(e.target)
              //解讀向左滾動距離
              const { scrollLeft } = e.target;
              // thead要先設定為可滾動
              // 才能調整thead滾動距離
              this.thead.current.scrollLeft = scrollLeft;

            }}
          >
            <AutoSizer>
              {size => {
                const { height, width } = size;
                return (
                  <List
                    ref={listRef}
                    sheetwidth={sheetwidth}
                    itemCount={data.length}
                    itemSize={24}
                    className="data-grid"
                    itemData={{}}
                    height={height}
                    width={width}
                  >
                    {this.renderRow}
                  </List>)
              }}
            </AutoSizer>
          </div>
          <tfoot style={{ width: defaultWidth }}>
            <tr>
              <ButtonToggle OriginalColumns={OriginalColumns} setColumns={setColumns} setFrozen={setFrozen} FrozenColumn={FrozenColumn}
                setOrderRows={setOrderRows} OriginalRows={OriginalRows}
              />
              <Pagination count={pageCount} shape="rounded" color="primary"
                siblingCount={0}
                size="small"
                page={pageNo}
                onChange={this.handlePageChange}
                style={{ display: "inline-flex" }}
              />
              <td colSpan={500} className="footFloat">
                <span >Count: <span className="fontBlack">{labelCount.count.toLocaleString(undefined, {
                  minimumFractionDigits: 0
                })} </span></span>
                {(labelCount.count2 === 0) ? null :
                  <span >
                    Sum: <span className="fontBlack">{labelCount.sum.toLocaleString(undefined, {
                      minimumFractionDigits: 2
                    })}
                      <span> </span>
                    </span>
                    Average: <span className="fontBlack">{labelCount.avg.toLocaleString(undefined, {
                      minimumFractionDigits: 2
                    })}
                    </span>
                  </span>
                }
              </td>

            </tr>
          </tfoot>

        </table>

      </div>
    );
  }

  renderRow = ({ index: rowIndex, style }) => {
    const { onRowClick, onRowDrop, checkSelections, columns, OriginalRows, selected, FrozenColumn, enableCheck, RowStyleFunc, handleDoubleClick } = this.props;
    const { start, end } = selected
    let startI = _.get(start, "i"), endI = _.get(end, "i")
    let startJ = _.get(start, "j"), endJ = _.get(end, "j")
    const sheetwidth = columns.reduce((a, b) => a + b.width, 0)
    const isisSelectRow = rowIndex >= startI && rowIndex <= endI || rowIndex <= startI && rowIndex >= endI
    return <Row style={style} rowIndex={rowIndex} grid={this} sheetwidth={sheetwidth} onRowClick={onRowClick} onRowDrop={onRowDrop}
      checkSelections={checkSelections} columns={columns} OriginalRows={OriginalRows}
      handleCheckSelectionChanges={this.handleCheckSelectionChanges}
      isSelect={isisSelectRow}
      isSelectJ={isisSelectRow ? (startJ - endJ === 0 ? endJ : endJ + 50) : 0}  //startJ - endJ === 0 同一格
      FrozenColumn={FrozenColumn}
      enableCheck={enableCheck}
      RowStyleFunc={RowStyleFunc}
      handleDoubleClick={handleDoubleClick}
    />;
  };
}
export default CommonHTML5Backend(VirtualSheet)

// VirtualSheet.defaultProps = {
//   cellRenderer: Cell
// };
const RowHeader = memo(rowDropTarget(rowDragSource(props => {
  const { isOver, rowIndex, onRowClick, connectDropTarget, connectDragSource } = props;
  const className = isOver ? 'drop-target' : ''; //拖曳變色
  // console.log(props)
  return connectDropTarget(
    connectDragSource(
      //若數字為數太多，字體變小
      <td onMouseDown={onRowClick} className={className + ' cell read-only row-handle'} title={rowIndex + 1} >
        <span style={rowIndex + 1 > 999 ? { fontSize: "8px" } : null}>{rowIndex + 1}</span>
      </td>))
})), isEqual)

const ChkBox = React.memo((props) => {
  // console.log(props)
  const { rowIndex, checkSelections } = props;
  const [playActive] = useSound(
    clickdown,
    { volume: 0.25 }
  );
  const [playOn] = useSound(
    clickup,
    { volume: 0.25 }
  );
  return (
    <Checkbox
      key={rowIndex}
      style={{ padding: 0, width: '100%', borderRadius: "0" }}
      color="primary"
      checked={checkSelections.get(rowIndex) || false}
      onChange={e => { props.handleCheckSelectionChanges(e, rowIndex) }}
      onMouseDown={() => {
        checkSelections.get(rowIndex) ? playActive() : playOn();
      }}
    />)

})  //不要isEqual，避免checkSelections無法更新
const Row = memo((props) => {
  const { isOver, grid, rowIndex, style, onRowClick, onRowDrop, checkSelections, handleCheckSelectionChanges, sheetwidth, columns, OriginalRows, RowStyleFunc
    , isSelect, selected, startI, startJ, endI, endJ, start, end, isSelectJ, FrozenColumn, enableCheck, handleDoubleClick } = props;
  const {
    attributesRenderer,
    cellRenderer,
    valueRenderer,
    dataRenderer,
    valueViewer,
    dataEditor,
    data,
    forceEdit
  } = grid.props;

  const row = data[rowIndex];
  // console.log(row);
  // console.log(data);
  // console.log(rowIndex);
  const newStyle = _.cloneDeep(style);
  newStyle.width = enableCheck ? 84 + sheetwidth + 2 : 30 + sheetwidth + 2;
  // newStyle.background = new Date(OriginalRows[rowIndex]["SOMEDAY"]).getDate() % 2 != 0 ? "#e3f2fd" : ""
  newStyle.background = RowStyleFunc ? RowStyleFunc(OriginalRows, rowIndex) : ""
  // RowStyleFunc
  return (
    <div className="data-grid-row" style={newStyle}>
      <RowHeader onRowClick={useCallback(() => onRowClick(rowIndex), [])} rowIndex={rowIndex} onRowDrop={onRowDrop} />
      {enableCheck ? (
        <td className='cell action-cell'>
          <ChkBox
            rowIndex={rowIndex}
            checkSelections={checkSelections}
            handleCheckSelectionChanges={handleCheckSelectionChanges}
          // ary={React.useMemo(()=>[],[])}
          />
        </td>
      ) : null}
      <RowToCell row={row} grid={grid} rowIndex={rowIndex} columns={columns}
        isSelect={isSelect}
        // startI={startI}
        // startJ={startJ}
        // endI={endI}
        // endJ={endJ}
        // start={start}
        // end={end}
        isSelectJ={isSelectJ}
        FrozenColumn={FrozenColumn}
        handleDoubleClick={handleDoubleClick}
      // selected={useMemo(() => selected, [diffJ])}
      />

    </div>
  );
})

const RowToCell = props => {

  const { row, grid, rowIndex, columns, isSelectJ } = props;
  // console.log(grid)
  const {
    attributesRenderer,
    cellRenderer,
    valueRenderer,
    dataRenderer,
    valueViewer,
    dataEditor,
    data,
    forceEdit,
    selected,
    handleDoubleClick
  } = grid.props;
  // console.log(isSelectJ)
  return (
    row.map((cell, colIndex) => {
      const isEditing = grid.isEditing(rowIndex, colIndex);
      // console.log(cell);
      return (
        <MyCell
          key={cell.key ? cell.key : `${rowIndex}-${colIndex}`}
          row={rowIndex}
          col={colIndex}
          cell={cell}
          forceEdit={forceEdit}
          onMouseDown={grid.onMouseDown}
          onMouseOver={grid.onMouseOver}
          onDoubleClick={handleDoubleClick}
          onContextMenu={grid.onContextMenu}
          onChange={grid.onChange}
          onRevert={grid.onRevert}
          onNavigate={grid.handleKeyboardCellMovement}
          onKey={grid.handleKey}
          selected={grid.isSelected(rowIndex, colIndex)}
          editing={isEditing}
          clearing={grid.isClearing(rowIndex, colIndex)}
          attributesRenderer={attributesRenderer}
          cellRenderer={cellRenderer}
          // valueRenderer={valueRenderer}
          valueRenderer={c => { return (columns[colIndex].format || "") === 'Amount' ? PF.ccyFormat(c.value, 2) : c.value }}
          dataRenderer={dataRenderer}
          valueViewer={valueViewer}
          dataEditor={dataEditor}
          editValue={grid.state.editValue}
          {...(isEditing
            ? {
              onEdit: grid.handleEdit
            }
            : {})}
        />


      );
    })

  )
}

const someEqual = (prevProps, nextProps) => {
  /*
  如果把 nextProps 传入 render 方法的返回结果与
  将 prevProps 传入 render 方法的返回结果一致则返回 true，
  否则返回 false
*/
  return prevProps !== nextProps
}


const MyCell = memo(props => {


  const { key, row, col, cell, forceEdit,
    onMouseDown, onMouseOver, onContextMenu, onDoubleClick, onChange, onRevert, onNavigate,
    onKey, selected, editing, clearing, attributesRenderer, cellRenderer, valueRenderer, dataRenderer, valueViewer,
    dataEditor, editValue
  } = props;

  return (
    <DataCell
      key={key}
      row={row}
      col={col}
      cell={cell}
      forceEdit={forceEdit}
      onMouseDown={onMouseDown}
      onMouseOver={onMouseOver}
      onDoubleClick={onDoubleClick}
      onContextMenu={onContextMenu}
      onChange={onChange}
      onRevert={onRevert}
      onNavigate={onNavigate}
      onKey={onKey}
      selected={selected}
      editing={editing}
      clearing={clearing}
      attributesRenderer={attributesRenderer}
      cellRenderer={cellRenderer}
      valueRenderer={valueRenderer}
      // valueRenderer={c => { return (columns[colIndex].format || "") === 'Amount' ? PF.ccyFormat(c.value, 2) : c.value }}
      dataRenderer={dataRenderer}
      valueViewer={valueViewer}
      dataEditor={dataEditor}
      editValue={editValue}
      {...props}
    />
  )
}, isEqual)